import PropTypes from 'prop-types';
import React, { Component } from 'react';
import DatePicker from 'material-ui/DatePicker';
import { AgendaIcon } from '../icons';
import styles from './style';
import TextField from '../TextField';
import Context from 'managers/Context';
import formatDate from 'utils/dates';

let DateTimeFormat = global.Intl.DateTimeFormat;

const propTypes = {
    onChange: PropTypes.func,
    locale: PropTypes.string,
};

// TODO REFACTOR
class DateFieldFm extends Component {
    state = { text: undefined, showClear: false };

    constructor(props) {
        super(props);
        const { error, value } = props;
        this.state = this.setDefaultState(props);
    }

    // UNSAFE_componentWillReceiveProps() {
    //     this.setState(this.setDefaultState(this.props));
    // }

    setDefaultState(props) {
        const { error, value } = props;
        // getStringfromDate is terrible, we need to pass the format we are sending to create the moment
        return {
            error: error,
            text: value,
            textField: value ? Context.utilsFormats.getStringfromDate(value) : value,
            showClear: value !== null && value !== undefined,
        };
    }

    getValue = () => {
        return this.textfield.getValue();
    };

    onChange = (e, date) => {
        let { onChange } = this.props;

        onChange && onChange(e, date);
        this.setState({ showClear: date !== undefined, text: date });
    };

    clear = () => {
        this.setState({ textField: undefined });
        this.onChange(undefined, undefined);
    };

    onBlur = () => {
        const { textField } = this.state;
        if (textField) {
            const text = Context.utilsFormats.getDatefromString(textField);
            if (text.toString().toLowerCase() !== 'invalid date') {
                this.onChange(undefined, text);
            } else {
                this.clear();
                // this.setState({textField: undefined});
                // this.onChange(undefined,undefined);
            }
        }
    };

    onChangeText = (value) => {
        const { textField } = this.state;
        if (!value || value === '') {
            this.clear();
        }
        value = value.replace(/[^-/0-9\s]/g, '');
        this.setState({ textField: value ? value : undefined });
    };

    getLocale() {
        let locale = this.props.locale;
        if (!locale && Context?.config?.userData) locale = Context?.config?.userData?.locale;
        return locale || 'es-ES';
    }

    render() {
        let { disabled, id } = this.props;
        let { text, showClear, error, textField } = this.state;
        let finalLocale = this.getLocale();
        id = id ? 'text-' + id : 'text-' + Math.floor(Math.random() * 10000);
        error = error && !showClear ? error : '';
        text = text ? text : '';
        return (
            <div style={styles.container}>
                <TextField
                    id={id}
                    {...this.props}
                    autoCorrect="true"
                    errorText={error}
                    ref={(e) => (this.textfield = e)}
                    value={
                        textField
                            ? textField
                            : text
                              ? Context.utilsFormats.formatDateToString(text)
                              : text
                    }
                    onChangeText={this.onChangeText}
                    hintText={Context.utilsFormats.getDateFormatLocale().toLowerCase()}
                    onBlur={this.onBlur}
                    defaultValue=""
                />
                {text || textField ? null : disabled ? null : (
                    <AgendaIcon
                        style={styles.errorIcon}
                        onClick={() => {
                            this.props.onClick && this.props.onClick();
                            this.datePicker.focus();
                        }}
                    />
                )}
                <DatePicker
                    {...this.props}
                    errorText={error}
                    ref={(e) => (this.datePicker = e)}
                    value={text}
                    onChange={this.onChange}
                    DateTimeFormat={DateTimeFormat}
                    locale={finalLocale}
                    style={{ display: 'none' }}
                    autoOk={true}
                />
            </div>
        );
    }
}

DateFieldFm.propTypes = propTypes;

export default DateFieldFm;
